import { RoleGate } from '@/components/RoleGate';
import { AreasManager } from '@/features/workspaces/components/AreasManager';
import { getWorkspaceBySlugQuery } from '@/lib/supabase/queries/workspaces';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/$wsSlug/settings/areas')({
  component: AreasSettingsPage,
});

function AreasSettingsPage() {
  const { wsSlug } = Route.useParams();
  const { data: workspace } = useQuery(getWorkspaceBySlugQuery(wsSlug));
  const workspaceId = workspace?.id ?? '';

  if (!workspaceId) {
    return (
      <div className="flex items-center justify-center py-12 text-quiet text-sm">Cargando...</div>
    );
  }

  return (
    <RoleGate wsSlug={wsSlug}>
      <div className="max-w-2xl">
        <div className="mb-6">
          <h2 className="text-base font-semibold text-ink">Areas</h2>
          <p className="text-sm text-quiet">
            Catalogo de areas de trabajo del workspace. Sirven para clasificar y, mas adelante,
            dirigir alertas a sus responsables.
          </p>
        </div>
        <AreasManager workspaceId={workspaceId} />
      </div>
    </RoleGate>
  );
}
